import create, { SetState, StateCreator, StoreApi } from 'zustand'
interface Recommendation {
    patientId: string,
    isActionable: string,
    clinicalRcmdtnDesc: string,
    caremgrActionDate: string,
    rcmdtnInfo: string,
    lastEncounterDate:string,
    rcmdtnDisplayStatus:string,
    dataIndex?:number
}

interface RecommendationDataStore {
    data : Recommendation[],
    updateData : (x:any) => void
    actionableData : Recommendation[],
    setActionableData : (x:any) => void
    referenceData : Recommendation[],
    setReferenceData : (x:any) => void
    clearStore: () => void
}

let  store: StateCreator<RecommendationDataStore, [], [], RecommendationDataStore> | StoreApi<RecommendationDataStore> = (set: SetState<RecommendationDataStore>) => ({
    data: [],
    updateData: (x) => {
    set(state => ({ data : x }))
    },
    actionableData: [],
    setActionableData: (x) => {
    set(state => ({ actionableData : x }))
    },
    referenceData: [],
    setReferenceData: (x) => {
    set(state => ({ referenceData : x }))
    },
  clearStore: () => {
    set(() => ({data:  []}))
    set(() => ({actionableData:  []}))
    set(() => ({referenceData:  []}))
  }
})


export const useRecommendationDataStore  = create(store)